import { Component, Input } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { ConfigService } from '../../services/config.service';

@Component({
    selector: 'itpx-error',
    templateUrl: './error.component.html',
    styleUrls: [ './error.component.css' ]
})

export class ErrorComponent {
    @Input() message: string;

    constructor( private configService: ConfigService, private http: Http ) {
    }

}


// WEBPACK FOOTER //
// ./src/app/core/components/error/error.component.ts